export function samePageLinkNavigation(
  event: React.MouseEvent<HTMLDivElement, MouseEvent>
): boolean {
  if (
    event.defaultPrevented ||
    event.button !== 0 || // ignore everything but left-click
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    event.shiftKey
  ) {
    return false
  }
  return true
}
